import { IApuracaoSn, Situacao } from './api';

export const SITUACOES: Record<Situacao, { rotulo: string; cor: string; dica: string }> = {
  nao_calculada: {
    rotulo: 'Não calculada',
    cor: '#94A3B8',
    dica: 'Ainda não houve cálculo neste mês (o recálculo roda toda noite às 03:30).',
  },
  calculada: {
    rotulo: 'Em conferência',
    cor: '#F59E0B',
    dica: 'Calculada: falta tratar as pendências e aprovar.',
  },
  aprovada: {
    rotulo: 'Aprovada',
    cor: '#6366F1',
    dica: 'Aprovada, pronta para transmitir o PGDAS-D.',
  },
  transmitindo: {
    rotulo: 'Transmitindo',
    cor: '#0EA5E9',
    dica: 'Envio em andamento (ou o SERPRO não respondeu: o lote tenta de novo).',
  },
  transmitida: {
    rotulo: 'Transmitida',
    cor: '#14B8A6',
    dica: 'Declaração entregue; faltam DAS/extrato.',
  },
  concluida: {
    rotulo: 'Concluída',
    cor: '#22C55E',
    dica: 'Declaração, recibo, DAS e extrato salvos.',
  },
  erro: {
    rotulo: 'Erro',
    cor: '#EF4444',
    dica: 'O SERPRO recusou: veja a mensagem e as pendências.',
  },
};

export const TRIBUTOS: Record<string, string> = {
  irpj: 'IRPJ',
  csll: 'CSLL',
  cofins: 'COFINS',
  pis: 'PIS',
  cpp: 'CPP',
  icms: 'ICMS',
  ipi: 'IPI',
  iss: 'ISS',
};

export const FONTES_RBT12: Record<string, string> = {
  inicio_atividade: 'Início de atividade (proporcional)',
  receita: 'Receita Federal (rascunho PGDAS-D)',
  proprio: 'Calculado pelas notas dos 12 meses',
  manual: 'Informado manualmente',
  sem: 'Sem RBT12 confirmado',
};

export const TIPOS_ARQUIVO: Record<string, string> = {
  declaracao: 'Declaração',
  recibo: 'Recibo',
  das: 'DAS',
  extrato: 'Extrato',
  'maed-notificacao': 'Notificação MAED',
  'maed-darf': 'DARF MAED',
};

const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export function brl(v?: number | null): string {
  return v === null || v === undefined ? '—' : BRL.format(v);
}

export function pct(v?: number | null, casas = 2): string {
  return v === null || v === undefined
    ? '—'
    : `${(v * 100).toLocaleString('pt-BR', {
        minimumFractionDigits: casas,
        maximumFractionDigits: casas,
      })}%`;
}

export function dataBr(v?: string | null): string {
  if (!v) return '—';
  const [a, m, d] = v.slice(0, 10).split('-');
  return d ? `${d}/${m}/${a}` : v;
}

export function dataHoraBr(v?: string | null): string {
  if (!v) return '—';
  try {
    return new Date(v).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
  } catch {
    return v;
  }
}

export function cnpjFmt(v?: string | null): string {
  const d = (v ?? '').replace(/\D/g, '');
  if (d.length !== 14) return v ?? '';
  return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
}

/** Diferença relevante (> R$ 1) entre o nosso DAS e outro valor. */
export function diverge(nosso?: number | null, outro?: number | null): boolean {
  if (nosso === null || nosso === undefined || outro === null || outro === undefined) return false;
  return Math.abs(nosso - outro) > 1;
}

/** Variação % do DAS contra o mês anterior (null se não dá pra comparar). */
export function variacao(ap?: IApuracaoSn | null): number | null {
  if (!ap?.valor_mes_anterior || ap.valor_das === null) return null;
  return (ap.valor_das - ap.valor_mes_anterior) / ap.valor_mes_anterior;
}

export const EDITAVEL: Situacao[] = ['calculada', 'erro'];
